module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "right"
  }, [(_vm.priceList.length) ? _c('group', {
    attrs: {
      "title": "代理价格"
    }
  }, _vm._l((_vm.priceList), function(i) {
    return _c('cell', {
      key: i.cate_id
    }, [_c('div', {
      staticClass: "p",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(i.cate_info.name) + " "), (_vm.currentAgentList[i.cate_id]) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("(" + _vm._s(_vm.currentAgentList[i.cate_id]) + " 代理中)")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "c",
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }, [_vm._v(_vm._s(i.price) + " 元")])])
  })) : _vm._e(), _vm._v(" "), _c('group', {
    attrs: {
      "title": "咨询电话"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, _vm._l((_vm.call), function(no) {
    return _c('x-button', {
      key: no,
      staticStyle: {
        "border-radius": "30px"
      },
      attrs: {
        "plain": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.doCall(no)
        }
      }
    }, [_vm._v("详情咨询:" + _vm._s(no) + "\n                    ")])
  }))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76ff03de"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/JoinDetail.vue
// module id = 719
// module chunks = 0